import React from "react";
import { StyleSheet, useWindowDimensions, View } from "react-native";
import { FooterColumn } from "./footer-column";
import FooterSubscription from "./subscription-card";

export default function DesktopFooter(props) {
  const {
    footerData,
    token,
    userInfo,
    chargebee_billing_platform,
    locationInfo,
  } = props;
  const { width } = useWindowDimensions();
  const sections = footerData && footerData?.sections;
  const firstSection = sections && sections[0];
  const secondSection = sections && sections[1];
  const thirdSection = sections && sections[2];
  const fourthSection = sections && sections[3];
  const fifthSection = sections && sections[4];
  const sixthSection = sections && sections[5];

  if (width < 1024) {
    return null;
  }

  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <View style={styles.grid}>
          <FooterColumn {...firstSection} />
          <FooterColumn {...secondSection} />
          <FooterColumn {...thirdSection} />
          <FooterColumn {...fourthSection} />
          <FooterColumn {...fifthSection} />
          <FooterSubscription
            {...sixthSection}
            token={token}
            userInfo={userInfo}
            chargebee_billing_platform={chargebee_billing_platform}
            locationInfo={locationInfo}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "#f3eee2",
    display: "flex",
    paddingVertical: 64,
  },
  container: {
    alignSelf: "center",
    maxWidth: 1440,
    paddingHorizontal: 24,
    width: "100%",
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    gap: 32,
    width: "100%",
    justifyContent: "space-between",
  },
});
